import { createContext } from 'react'

/** Which products this deployment is running — `GET /api/v1/config/`. */
export type Features = {
  education: boolean
  payments: boolean
}

export type FeaturesState = {
  features: Features
  /** False while the first read is in flight. */
  ready: boolean
}

/**
 * Education defaults to **off** while the config request is in flight, and if
 * it fails outright.
 *
 * Failing closed matters here: the alternative flashes the education
 * navigation and then retracts it, and on a failed request it would leave links
 * pointing at routes the API answers 404 for. A product that is switched off
 * appearing briefly is worse than one that appears a moment late.
 */
export const DEFAULT_FEATURES: Features = {
  education: false,
  // Fails closed for the same reason education does, and one more: a Pay
  // button that appears and then retracts has already told the user they can
  // buy something they cannot.
  payments: false,
}

export const FeaturesContext = createContext<FeaturesState | null>(null)
